import { api } from 'constants/constant';
import { getHeaders } from 'auth/auth';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const reportsAPI = createApi({
  reducerPath: 'reports',
  baseQuery: fetchBaseQuery({ baseUrl: api, credentials: 'include' }),
  endpoints: (builder) => ({
    getReportsData: builder.query({
      query: ({ paging, searchFilter, date, dateString }) => {
        return {
          url: `b2b/loan/report/mis-report?page=${paging?.page}&page_size=${paging?.pageSize}&search=${searchFilter}` + dateString,
          method: 'GET',
          headers: getHeaders(),
        };
      },
    }),
    getPurposeInformation: builder.query({
      query: () => {
        return {
          url: `/b2b/loan/application_dropdowns/loan_purpose`,
          method: 'GET',
          headers: getHeaders(),
        };
      },
    }),
    downloadReportsData: builder.mutation({
      query: ({ paging, searchFilter, date, dateString }) => {
        return {
          url: `/b2b/loan/report/download-mis-report?page=${paging?.page}&page_size=${paging?.pageSize}&search=${searchFilter}` + dateString,
          method: 'GET',
          headers: getHeaders(),
          responseHandler: (response) => response.blob(),
        };
      },
      providesTags: ['downloadReports'],
    }),

    getMcrQuarterly: builder.query({
      query: ({ quarter }) => ({
        url: `b2b/loan/report/mcr-quarterly?quarter=${quarter}`,
        method: 'GET',
        headers: getHeaders(),
      }),
      transformResponse: (response) => response?.data || null,
    }),

    getLoanProduction: builder.query({
      query: (queryString) => ({
        url: `b2b/loan/report/loan-production?${queryString}`,
        method: 'GET',
        headers: getHeaders(),
      }),
      transformResponse: (response) => response?.data || null,
    }),

  }),
});

export const {
  useGetReportsDataQuery,
  useGetPurposeInformationQuery,
  useDownloadReportsDataMutation,
  useGetMcrQuarterlyQuery,
  useLazyGetMcrQuarterlyQuery,
  useGetLoanProductionQuery,
} = reportsAPI;
